module.exports = __webpack_public_path__ + "static/media/arrow-up.a1380251.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-up.svg
// module id = 2410
// module chunks = 0